import { createManualCheckAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: createManualCheckSlice, asyncAction: createManualCheckAction } = createAsyncSlice(
  'createManualCheckSlice',
  createManualCheckAsync
);
